// extracted by mini-css-extract-plugin
export var lbContainerOuter = "y_tS";
export var lbContainerInner = "y_tT";
export var movingForwards = "y_tV";
export var movingForwardsOther = "y_tW";
export var movingBackwards = "y_tX";
export var movingBackwardsOther = "y_tY";
export var lbImage = "y_tZ";
export var lbOtherImage = "y_t0";
export var prevButton = "y_t1";
export var nextButton = "y_t2";
export var closing = "y_t3";
export var appear = "y_t4";